import promiseActionCreator from '../promiseActionCreator';
import pollMiddleware from './middlewares/pollMiddleware';
import errorMiddleware from './middlewares/errorMiddleware';
import successMiddleware from './middlewares/successMiddleware';
export default promiseActionCreator.configure({
    config: {
        maxPollAttempts: 120,
        maxErrorAttempts: 2,
    },
    responseMiddlewares: [
        pollMiddleware,
        successMiddleware,
    ],
    errorMiddlewares: [
        errorMiddleware,
    ],
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpUHJvbWlzZUFjdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2FwaVByb21pc2VBY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxvQkFBb0IsTUFBTSx5QkFBeUIsQ0FBQztBQUUzRCxPQUFPLGNBQWMsTUFBTSw4QkFBOEIsQ0FBQztBQUMxRCxPQUFPLGVBQWUsTUFBTSwrQkFBK0IsQ0FBQztBQUM1RCxPQUFPLGlCQUFpQixNQUFNLGlDQUFpQyxDQUFDO0FBRWhFLGVBQ0Usb0JBQW9CLENBQUMsU0FBUyxDQUFtRDtJQUMvRSxNQUFNLEVBQUU7UUFDTixlQUFlLEVBQUUsR0FBRztRQUNwQixnQkFBZ0IsRUFBRSxDQUFDO0tBQ3BCO0lBQ0QsbUJBQW1CLEVBQUU7UUFDbkIsY0FBYztRQUNkLGlCQUFpQjtLQUNsQjtJQUNELGdCQUFnQixFQUFFO1FBQ2hCLGVBQWU7S0FDaEI7Q0FDRixDQUFDLENBQUMifQ==